import useMutation from "src/hooks/useMutation";

function useWarehouseTransferExport() {
  return useMutation({
    path: `/api/v1/warehouse-transfers/export-print-files`,
    method: "POST",
    // mutateRelatedDataList: {
    //   mutatePath: `/api/v1/warehouse-transfers`,
    //   shouldRevalidate: false,
    // },
  });
}

export default useWarehouseTransferExport;
